import React from 'react';
import InsightCard from './InsightCard';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';

interface OtherInsightsSectionProps {
  insights: string[];
}

const OtherInsightsSection: React.FC<OtherInsightsSectionProps> = ({ insights }) => {
  if (!insights || insights.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #38b2ac',
      breakInside: 'avoid'
    }}>
      <h2 style={{ color: '#38b2ac', marginBottom: '1rem', fontSize: '1.5rem', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
        <LightbulbOutlinedIcon style={{ marginRight: '8px' }} />
        Other Insights
      </h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {insights.map((insight: string, index: number) => (
          <InsightCard key={index} insight={insight} />
        ))}
      </ul>
    </div>
  );
};

export default OtherInsightsSection;
